module.exports = __webpack_public_path__ + "img/bg-video-6.66b68272.png";